import {dispatchTrackEvent} from "./_tracking";

export default function initAjax() {
  document.querySelectorAll('[data-ajax]').forEach((ajax) => {
    ajax.addEventListener(ajax.dataset.ajax, (e) => clickFetch(e.target, ajax.dataset))
  });
}

/**
 * Click handler for loading more posts
 * @param {Element} target
 * @param {*} dataSet
 */
function clickFetch(target, dataSet) {
  if (dataSet.ajaxPage < 1 || dataSet.ajaxClicked) return;
  target.setAttribute('data-ajax-clicked', 'true');

  // eslint-disable-next-line no-undef
  return fetch(ajax.url, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Cache-Control': 'no-cache',
    },
    body: new URLSearchParams({
      action: dataSet.ajaxAction,
      post: dataSet.ajaxPostType,
      perPage: dataSet.ajaxPostCount,
      categories: dataSet.ajaxPostCategories,
      page: dataSet.ajaxPage || '2',
    }),
  }).then(response => {
    if (!response.ok) {
      throw new Error('Invalid response');
    }
    return response.json();
  })
    .then(response => {
      target.setAttribute('data-ajax-page', response.page);
      if (response.page === -1) {
        target.classList.add('hidden');
      }
      insertPosts(response.posts, dataSet.ajaxAction);
      target.removeAttribute('data-ajax-clicked');

      trackAjaxLoad(target, dataSet.ajaxPostType);
    })
    .catch(error => console.error(error));
}

/**
 * Populates new posts
 * @param {Array} posts
 * @param {String} action
 */
function insertPosts(posts, action) {
  const fillTarget = document.querySelector(`[data-ajax-fill=${action}]`);

  posts.forEach((post) => {
    const link = document.createElement('a');
    link.href = post.permalink;
    link.className = `card ${fillTarget.dataset.ajaxCardStyle}`;

    const title = document.createElement('h4');
    title.innerHTML = post.title;

    if(post.category) {
      const category = document.createElement('p');
      category.className = `category ${post.category_color}`;
      category.innerHTML = post.category;

      link.appendChild(category);
    }

    link.innerHTML += post.thumbnail;

    const readmore = document.createElement('div');
    readmore.className = 'readmore';
    const readText = document.createElement('span');
    readText.className = 'text';
    readText.innerText = fillTarget.dataset.ajaxCardReadmore;
    readmore.appendChild(readText);

    link.appendChild(title);
    link.appendChild(readmore);
    fillTarget.appendChild(link);
  });
}

function trackAjaxLoad(target, label) {
  dispatchTrackEvent({
    'eventCategory': 'posts',
    'eventAction': 'load',
    'eventLabel': label,
    'eventValue': 5,
    'nonInteraction': false,
  }, target);
}
